// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export class AgentGroup {    
    id: string;
    name: string;
    displayName: string;
}
